import { useContext } from 'react'
import { AccountContext } from '@/contexts/account'

/**
 * ヘッダーに出す現在の施設の表示情報。
 * 施設基本情報は取得前・取得失敗のことがあるため、アカウント側の施設名にフォールバックする。
 */
export const useCurrentHotel = () => {
  const { account, basicInfo } = useContext<any>(AccountContext)

  return {
    hotelName: basicInfo?.hotelName || account?.hotel?.name || '',
    logoImageSrc: basicInfo?.logoImageId || require('@/static/images/header/aipassLogo.svg'),
  }
}
